export default __webpack_public_path__ + "static/media/Db4.88f41eba.mp3";